import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { trigger, transition, state, animate, style, AnimationEvent, AUTO_STYLE } from '@angular/animations';
const DEFAULT_DURATION = 300;
@Component({
  selector: 'app-nft-features',
  templateUrl: './nft-features.component.html',
  styleUrls: ['./nft-features.component.css'],
  // animations: [
  //   trigger('collapse', [
  //     state('false', style({ height: AUTO_STYLE, display: AUTO_STYLE })),
  //     state('true', style({ height: '0', display: 'none' })),
  //     transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in-out')),
  //     transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out-out'))

  //   ])
  // ],
})
export class NftFeaturesComponent implements OnInit {
  public isNftGenCollapsed: boolean = true;
  public isNftBulkGenCollapsed: boolean = true;
  public isNftAirdropCollapsed: boolean = true;
  public isNftLockerCollapsed: boolean = true;
  public isNftLaunchpadCollapsed: boolean = true;
  public isnftFeatureExpanded: number = 1;
  constructor(
    private changeDetector: ChangeDetectorRef

  ) { }

  ngOnInit(): void {
  }

  toggle(index: number) {
    if (this.isnftFeatureExpanded == index) {
      this.isnftFeatureExpanded = 0;
    } else {
      this.isnftFeatureExpanded = index;

    }
  }
  toggleNftGen() {
    this.isNftGenCollapsed = !this.isNftGenCollapsed;
    // this.isNftGenCollapsed=false
    this.isNftBulkGenCollapsed = true;
    this.isNftAirdropCollapsed = true;
    this.isNftLockerCollapsed = true;
    this.isNftLaunchpadCollapsed = true;
    this.changeDetector.detectChanges()

  }

  toggleNftBulkGen() {

    this.isNftBulkGenCollapsed = !this.isNftBulkGenCollapsed;

    this.isNftGenCollapsed = false;


    // this.isNftGenCollapsed = false;
    this.isNftAirdropCollapsed = true;
    this.isNftLockerCollapsed = true;
    this.isNftLaunchpadCollapsed = true;
  }

  toggleNftAirdrop() {
    this.isNftAirdropCollapsed = !this.isNftAirdropCollapsed;
    this.isNftGenCollapsed = false;

    this.isNftBulkGenCollapsed = true;
    this.isNftLockerCollapsed = true;
    this.isNftLaunchpadCollapsed = true;

  }

  toggleNftLocker() {
    this.isNftLockerCollapsed = !this.isNftLockerCollapsed;
    this.isNftGenCollapsed = false;
    this.isNftBulkGenCollapsed = true;
    this.isNftAirdropCollapsed = true;
    this.isNftLaunchpadCollapsed = true;

  }

  toggleNftLaunchpad() {
    this.isNftLaunchpadCollapsed = !this.isNftLaunchpadCollapsed;
    this.isNftGenCollapsed = false;

    this.isNftBulkGenCollapsed = true;
    this.isNftAirdropCollapsed = true;
    this.isNftLockerCollapsed = true;

  }


}
